import React from 'react'

import { Button, ButtonClean, Icon, Tooltip, useModalContext } from '@fourthwall/components'
import { QuestionMarkIcon } from '@fourthwall/icons'
import { useFormikContext } from '@fourthwall/utils/dist/formik'
import { getCountryNameByCode, getStateNameByCode } from '@fourthwall/utils/dist/inputs'

import type { FormValues, ShippingLocation as ShippingLocationType } from '../../Shipping.types'
import { ShippingLocationModal } from '../ShippingLocationModal/ShippingLocationModal'
import * as S from './ShippingLocation.styled'

export const ShippingLocation = () => {
  const formik = useFormikContext<FormValues>()
  const { open } = useModalContext()

  const handleShippingLocationModalSubmit = (values: ShippingLocationType) => {
    formik.setFieldValue('shippingLocation', values)
  }

  const handleSetupShippingLocation = () => {
    open(ShippingLocationModal, {
      shippingLocation: formik.values.shippingLocation,
      title: formik.values.shippingLocation
        ? 'Edit your shipping location'
        : 'Setup your shipping location',
      onSubmit: handleShippingLocationModalSubmit,
    })
  }

  const shippingLocation = formik.values.shippingLocation

  const renderState = () => {
    if (shippingLocation?.state && shippingLocation?.country) {
      return getStateNameByCode(shippingLocation?.country, shippingLocation.state)
    }

    return shippingLocation?.state
  }

  const renderCountry = () => {
    if (shippingLocation?.country) {
      return getCountryNameByCode(shippingLocation?.country)
    }

    return shippingLocation?.country
  }

  return (
    <>
      <S.ShippingLocationHeader>
        Your shipping location
        <S.ShippingLocationTooltip>
          <Tooltip
            reference={<Icon component={QuestionMarkIcon} height={18.75} />}
            placement="top"
            fluid
          >
            This address is used to calculate shipping costs and taxes. Your supporters do not see
            it.{' '}
          </Tooltip>
        </S.ShippingLocationTooltip>
      </S.ShippingLocationHeader>

      {!shippingLocation && (
        <div style={{ marginTop: '16px' }}>
          <Button
            label="Setup your shipping location"
            appearance="primary"
            onClick={handleSetupShippingLocation}
          />
        </div>
      )}

      {shippingLocation && (
        <>
          <S.ShippingLocationContent>
            {shippingLocation.address1} <br />
            {shippingLocation.address2 && (
              <>
                {shippingLocation.address2}
                <br />
              </>
            )}
            {renderState()} {shippingLocation.zip} {shippingLocation.city} <br />
            {renderCountry()}
          </S.ShippingLocationContent>
          <S.ShippingLocationEditButtonContainer>
            <ButtonClean label="Edit shipping location" onClick={handleSetupShippingLocation} />
          </S.ShippingLocationEditButtonContainer>
        </>
      )}
    </>
  )
}
